import React from 'react';

const FAQHero = ({ searchQuery, onSearchChange }) => {
  return (
    <section style={{ position: 'relative', minHeight: '520px', overflow: 'hidden', background: '#050A12' }}>
      {/* Background image */}
      <img
        src="https://img.rocket.new/generatedImages/rocket_gen_img_1217eb179-1772191889926.png"
        alt="Norwegian mountain road with dramatic sky and road signs pointing in multiple directions"
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 30%', filter: 'brightness(0.25) contrast(1.2) saturate(0.6)' }} />
      
      {/* Diagonal overlay */}
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(5,10,18,0.95) 0%, rgba(5,10,18,0.6) 50%, rgba(59,111,212,0.15) 100%)' }} />
      {/* Orange accent bar */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '4px', background: 'linear-gradient(90deg, #E8521A 0%, #3B6FD4 100%)' }} />
      {/* Rotated label */}
      <div style={{
        position: 'absolute', top: '80px', right: '8%',
        fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem', fontWeight: 700,
        color: 'rgba(232,82,26,0.7)', letterSpacing: '0.2em', textTransform: 'uppercase',
        transform: 'rotate(90deg)', transformOrigin: 'right center'
      }}>SPØRSMÅL & SVAR</div>
      {/* Content */}
      <div style={{ position: 'relative', zIndex: 2, maxWidth: '1400px', margin: '0 auto', padding: '120px 5% 80px' }}>
        {/* Category tag */}
        <div style={{
          display: 'inline-block', background: '#E8521A', padding: '4px 14px',
          fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem', fontWeight: 700,
          color: '#EEF0F2', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '24px'
        }}>HJELPESENTER</div>
        {/* Main heading */}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px', marginBottom: '16px' }}>
          <div style={{
            fontFamily: 'Syne, sans-serif', fontSize: 'clamp(3rem, 8vw, 7rem)',
            fontWeight: 800, color: '#EEF0F2', letterSpacing: '-0.04em', lineHeight: 0.9
          }}>FAQ</div>
          <div style={{ paddingTop: '12px' }}>
            <div style={{
              fontFamily: 'Lora, serif', fontStyle: 'italic',
              fontSize: 'clamp(1rem, 2vw, 1.5rem)', color: 'rgba(238,240,242,0.5)', lineHeight: 1.3
            }}>Ofte stilte<br />spørsmål</div>
          </div>
        </div>
        {/* Subtitle */}
        <p style={{
          fontFamily: 'Inter, sans-serif', fontSize: '1.0625rem',
          color: 'rgba(138,149,163,0.8)', maxWidth: '520px', lineHeight: 1.7, marginBottom: '48px'
        }}>Finn svar på de vanligste spørsmålene om NordPass — fra konto og fakturering til bomkalkulator og teknisk støtte.</p>
        {/* Search bar */}
        <div style={{ position: 'relative', maxWidth: '560px' }}>
          <div style={{
            position: 'absolute', left: '18px', top: '50%', transform: 'translateY(-50%)',
            fontFamily: 'JetBrains Mono, monospace', fontSize: '1rem', color: '#3B6FD4'
          }}>⌕</div>
          <input
            type="text"
            placeholder="Søk i spørsmål og svar..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            style={{
              width: '100%', padding: '18px 18px 18px 52px',
              background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(59,111,212,0.3)',
              color: '#EEF0F2', fontFamily: 'Inter, sans-serif', fontSize: '0.9375rem',
              outline: 'none', boxSizing: 'border-box',
              transition: 'border-color 200ms ease'
            }}
            onFocus={(e) => {e.target.style.borderColor = '#3B6FD4';e.target.style.background = 'rgba(59,111,212,0.06)';}}
            onBlur={(e) => {e.target.style.borderColor = 'rgba(59,111,212,0.3)';e.target.style.background = 'rgba(255,255,255,0.04)';}} />
          
          {searchQuery &&
          <button
            onClick={() => onSearchChange('')}
            style={{
              position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)',
              background: 'none', border: 'none', color: 'rgba(138,149,163,0.6)',
              cursor: 'pointer', fontSize: '1.1rem', padding: '4px'
            }}>✕</button>
          }
        </div>
        {/* Stats row */}
        <div style={{ display: 'flex', gap: '40px', marginTop: '48px', flexWrap: 'wrap' }}>
          {[{ num: '4', label: 'Kategorier' }, { num: '32', label: 'Spørsmål' }, { num: '< 2 min', label: 'Gjennomsnittlig lesetid' }]?.map((s, i) =>
          <div key={i}>
              <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '1.75rem', fontWeight: 800, color: '#3B6FD4', letterSpacing: '-0.03em' }}>{s?.num}</div>
              <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: 'rgba(138,149,163,0.6)', letterSpacing: '0.08em', textTransform: 'uppercase', marginTop: '2px' }}>{s?.label}</div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default FAQHero;